import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import TruncatedText from 'components/TruncatedText';
import { DataRoomRFICategory } from 'router/subrouters/DataRoom/models/DataRoomRfi';
import { getArrayLength, getHasElementsInArray } from 'utils';
import { getFormattedDate } from 'dateUtils';
import useRfiCategory from 'hooks/useRfiCategory';
import {
  getLatestUploadedFile,
  UPLOAD_STATUS_COLOR,
  UPLOAD_STATUS_LABEL_KEYS,
} from '../../../utils';

export type CategoryCellProps = {
  category: DataRoomRFICategory;
};

export const NameCell: React.FC<CategoryCellProps> = ({ category }) => {
  const { getCategoryName } = useRfiCategory();

  const name = getCategoryName(category.name);

  return (
    <p className="rfi-categories-table__truncated-name" title={name}>
      {name}
    </p>
  );
};

export const TruncatedTextWithCount: React.FC<{
  text: string;
  count: number;
}> = ({ text, count }) => {
  const extraItemsCount = Math.max(count - 1, 0);

  return (
    <p className="rfi-categories-table__ellipsis-row">
      <TruncatedText text={text} />

      {!!extraItemsCount && (
        <span className="rfi-categories-table__muted-text">
          +{extraItemsCount}
        </span>
      )}
    </p>
  );
};

export const FilesCell: React.FC<CategoryCellProps> = ({ category }) => {
  const { files } = category;

  if (!getHasElementsInArray(files)) {
    return <p>/</p>;
  }

  const latestFile = getLatestUploadedFile(files);

  return (
    <TruncatedTextWithCount
      text={latestFile.file?.name}
      count={getArrayLength(files)}
    />
  );
};

export const UploadedOnCell: React.FC<CategoryCellProps> = ({ category }) => {
  const latestFile = getLatestUploadedFile(category.files);

  return <p>{latestFile ? getFormattedDate(latestFile.createdAt) : '/'}</p>;
};

export const StatusCell: React.FC<CategoryCellProps> = ({ category }) => {
  const { t } = useTranslation();

  const { uploadStatus } = category || {};

  return (
    <span
      className={classNames(
        'rfi-categories-table__status',
        UPLOAD_STATUS_COLOR[uploadStatus],
      )}
    >
      {t(UPLOAD_STATUS_LABEL_KEYS[uploadStatus])}
    </span>
  );
};
